import TrophyService from "../../services/trophy-service"
import { makeTrophyResource } from "../resources/trophy-resource-factory"

export const makeTrophyService = (): TrophyService => {
  return new TrophyService(makeTrophyResource())
}
